import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.years,"item-value":"id","item-text":"name","label":"Year","rules":[_vm.requiredCheck()],"outlined":"","dense":_vm.dense != null ? _vm.dense : false,"hide-details":_vm.hideDetails != null ? _vm.hideDetails : false,"disabled":_vm.disabled},model:{value:(_vm.yearSelected),callback:function ($$v) {_vm.yearSelected=$$v},expression:"yearSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }